import { useContext } from "react";
import Auth0Context, { Auth0ContextInterface } from "./Auth0Context";

const useAuth0 = (): Auth0ContextInterface =>
  useContext<Auth0ContextInterface>(Auth0Context);

export default useAuth0;
